var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type == 'success')?_c('span',{staticClass:"px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 mr-2 mb-2"},[_vm._v(_vm._s(_vm.value))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }